/* eslint-disable react/jsx-no-duplicate-props */
import React, { useState } from 'react'
import { useHistory } from "react-router-dom";
import styled from 'styled-components'
import ContentArea from '../components/ContentArea'
import SelectButton from '../components/SelectButton'
import ButtonComponent from '../components/ButtonComponent'
import ReactGA from 'react-ga'

const RelaxationPage = () => {
  const HomeHeader = styled.h1`
    font-weight: 500;
    width: 70%;
    margin: 0 auto 53pt !important;
    text-align: center;
    font-size: 30pt;

    @media screen and (min-width: 768px) {
      margin-bottom: 3rem !important;
    }
  `
  const [isHidden, setIsHidden] = useState(true)
  let history = useHistory();

  const selectRelaxType = (e) => {
    e.preventDefault()
    let path = e.target.innerHTML
    let pathArray = path.split(" ")
    history.push(`/player/` + path.split(" ")[0].toLowerCase() + `/` + pathArray[pathArray.length - 3])
    setIsHidden(!isHidden)
  }
  const hideElements = () => {
    setIsHidden(!isHidden)
  }


  return (
    <ContentArea transparent shadowless fullsize>
      {isHidden && (
        <div>
          <div>
            <HomeHeader>Relaxation </HomeHeader>
            <ButtonComponent text="Preparing for Treatment" link="/relaxation/introduction" />
            <SelectButton value={"Guided Relaxation"} onclick={hideElements} />
          </div>
        </div>
      )
      }
      {!isHidden && (
        <div>
          <div>
            <HomeHeader>Choose a meditation</HomeHeader>
            <SelectButton
              value={"60 to Zero in 10 Seconds"}
              onclick={
                ReactGA.event({
                  category: "60 to Zero in 10 Seconds",
                  action: 'Meditation',
                  label: `3 minutes`
                }),
                selectRelaxType
              }
            />
            <SelectButton
              value={"Medical Support"}
              onclick={
                ReactGA.event({
                  category: "Medical Support",
                  action: 'Meditation',
                  label: `10 minutes`
                }),
                selectRelaxType
              }
            />
            <SelectButton
              value={"Peace & Calm"}
              onclick={
                ReactGA.event({
                  category: "Peace & Calm",
                  action: 'Meditation',
                  label: `16 minutes`
                }),
                selectRelaxType
              }
            />

          </div>
        </div>
      )}
    </ContentArea>
  )
}

export default RelaxationPage
